// ...existing code...
import toast from "react-hot-toast";
import { retrieveMenuItemsByTypeApi } from "../components/api/MenuItemApiService";

const _menuCache = new Map(); // Map<type, { items: Array, ts: number }>
const _menuPromises = new Map(); // Map<type, Promise>

const CACHE_TTL_MS = 60 * 60 * 1000; // 60 minutes

export const fetchMenuItemsCached = async (type, { force = false } = {}) => {
  // return cached if present and not expired (unless force = true)
  if (!force && _menuCache.has(type)) {
    const entry = _menuCache.get(type);
    if (entry && (Date.now() - entry.ts) < CACHE_TTL_MS) {
      return entry.items;
    }
    // expired -> delete so flow continues to fetch fresh
    _menuCache.delete(type);
  }

  // dedupe concurrent fetches
  if (_menuPromises.has(type)) {
    return _menuPromises.get(type);
  }

  const prom = (async () => {
    try {
      const resp = await retrieveMenuItemsByTypeApi(type);
      const items = resp?.data || [];
      _menuCache.set(type, { items, ts: Date.now() });
      return items;
    } catch (err) {
      console.error(`Error fetching ${type} menu items:`, err);
      toast.error(`Failed to load ${type} options`);
      return [];
    } finally {
      _menuPromises.delete(type);
    }
  })();

  _menuPromises.set(type, prom);
  return prom;
};

export const invalidateMenuCache = (type) => {
  if (type) _menuCache.delete(type);
  else _menuCache.clear();
};
// ...existing code...